import { createReducer } from '@reduxjs/toolkit';

import {
    FETCH_USER_INFO,
    REPLACE_USER_INFO,
    BACKEND_CARD_UPDATE_USER_INFO,
    BACKEND_CARD_UPDATE_USER_INFO_ERROR,
    BACKEND_CREATE_DEDUCTION,
    STORE_REPLACE_DEDUCTION,
    STORE_REPLACE_DEDUCTION_ERROR,
} from '@perpay-web/fintech/constants/actionTypes';

const initialState = {
    submitting: false,
    loading: true,
    fetchingPinwheelToken: false,
    errors: {},
};

const cardOnboardingReducer = createReducer(initialState, (builder) => {
    builder.addCase(FETCH_USER_INFO, (state) => ({
        ...state,
        loading: true,
    }));
    builder.addCase(REPLACE_USER_INFO, (state) => ({
        ...state,
        loading: false,
        submitting: false,
    }));
    builder.addCase(BACKEND_CARD_UPDATE_USER_INFO, (state) => ({
        ...state,
        submitting: true,
    }));
    builder.addCase(BACKEND_CARD_UPDATE_USER_INFO_ERROR, (state, action) => ({
        ...state,
        submitting: false,
        errors: action.payload,
    }));
    builder.addCase(BACKEND_CREATE_DEDUCTION, (state) => ({
        ...state,
        fetchingPinwheelToken: true,
    }));
    builder.addCase(STORE_REPLACE_DEDUCTION, (state) => ({
        ...state,
        fetchingPinwheelToken: false,
    }));
    builder.addCase(STORE_REPLACE_DEDUCTION_ERROR, (state, action) => ({
        ...state,
        fetchingPinwheelToken: false,
        errors: action.payload,
    }));
});

export default cardOnboardingReducer;
